import { render, staticRenderFns } from "./ReturnReasonForm.vue?vue&type=template&id=128dcd98&"
import script from "./ReturnReasonForm.vue?vue&type=script&lang=js&"
export * from "./ReturnReasonForm.vue?vue&type=script&lang=js&"
import style0 from "./ReturnReasonForm.vue?vue&type=style&index=0&id=128dcd98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports